import { useCallback, useMemo, useState } from "react";

/// A dialog opened with a payload (`true` when it carries none), plus the busy
/// flag and error its confirm action reports.
export function useDialog<T = true, E = string>() {
  const [payload, setPayload] = useState<T | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<E | null>(null);
  // Wrapped: a function payload would otherwise run as a state updater.
  const show = useCallback((next: T) => setPayload(() => next), []);
  const close = useCallback(() => setPayload(null), []);
  return useMemo(
    () => ({
      open: payload !== null,
      payload,
      show,
      close,
      busy,
      setBusy,
      error,
      setError,
    }),
    [payload, show, close, busy, error],
  );
}

export type Dialog<T = true, E = string> = ReturnType<typeof useDialog<T, E>>;
